<section class="divider !border-b-0 grid gap-8 lg:mt-0 lg:grid-cols-1" aria-hidden="true">
	<div class="flex flex-col">
		<div
			class="px-6 py-12 overflow-hidden border border-gray-200 rounded-lg bg-gray-50"
		>
			<div class="flex justify-center mb-6">
				<uc-house-svg customStyles="w-6 h-6 mr-0.5 p-0.5" />
				<uc-key-svg />
				<uc-office-svg customStyles="w-6 h-6 p-0.5" />
			</div>
			<h2 class="m-auto text-xl font-bold leading-6 text-center">Accommodation</h2>
			<p class="max-w-4xl px-6 m-auto mt-3 text-base text-center text-gray-500">
				Unfortunately, we're unable to gather accommodation for this university.
				<a
					(click)="onVisitWebsiteClick()"
					class="font-bold text-gray-800 underline"
					[attr.href]="universityExternalUrl()"
					rel="noopener sponsored"
					target="_blank"
					data-cy="no-accommodation-visit-website"
					>Click here</a
				>
				to find out more about possible accommodation options on the university's
				website.
			</p>
		</div>
	</div>
</section>
